// @core/api/endpoints/subscription/create_plan.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreatePlanRequest,
  PlanResponse,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Create a new subscription plan
 * Creates a new subscription plan with pricing, billing cycle, and feature definitions. Plans can be public or private for specific tenants.
 */
export async function CreatePlan(
  data: CreatePlanRequest,
  options?: RequestOptions
): Promise<PlanResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/plans`;
  const requestOptions = options;
  return client.post<PlanResponse>(requestPath, data, requestOptions);
}
